import React from "react";
import { Keyboard, Hand } from "lucide-react";
import { useIsTouch } from "@/hooks/useIsTouch";

// Device-aware movement/interaction instruction shown atop each walkable scene.
export const MoveHint = ({ verb = "interact" }) => {
  const touch = useIsTouch();
  return (
    <span
      data-testid="move-hint"
      className="flex items-center gap-1.5 rounded-md border-2 border-kirana-border bg-card px-2 py-1 text-xs text-kirana-brown/70"
    >
      {touch ? (
        <>
          <Hand className="h-3.5 w-3.5" /> Tap to move · Tap to {verb}
        </>
      ) : (
        <>
          <Keyboard className="h-3.5 w-3.5" /> WASD / Arrow Keys to walk · ↵ Enter to {verb}
        </>
      )}
    </span>
  );
};
